import {
  SET_LOGOUT,
  SET_FORCE_LOGOUT,
  SET_PASSWORD_EXPIRED,
  CLEAR_PASSWORD_EXPIRED,
} from '../actions/constants';

// Re-hydrate the password-expired flag from localStorage on module load so it
// survives a page refresh / tab reopen. Cleared on logout (see utils.ts) and
// on successful change-password (see Account.tsx).
const isPasswordExpiredOnBoot =
  typeof window !== 'undefined' &&
  window.localStorage?.getItem('passwordExpired') === '1';

const defaultState = {
  logout: false,
  forceLogout: false,
  passwordExpired: isPasswordExpiredOnBoot,
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case SET_LOGOUT: {
      return {
        ...state,
        logout: true,
        forceLogout: false,
        passwordExpired: false,
      };
    }
    case SET_FORCE_LOGOUT:
      return {
        ...state,
        logout: false,
        forceLogout: true,
        passwordExpired: false,
      };
    case SET_PASSWORD_EXPIRED:
      return {
        ...state,
        passwordExpired: true,
      };
    case CLEAR_PASSWORD_EXPIRED:
      return {
        ...state,
        passwordExpired: false,
      };
    default:
      return state;
  }
}
